import { render } from "./ExamsResultsView.vue?vue&type=template&id=6f917fd2&scoped=true"
import script from "./ExamsResultsView.vue?vue&type=script&lang=js"
export * from "./ExamsResultsView.vue?vue&type=script&lang=js"

import "./ExamsResultsView.vue?vue&type=style&index=0&id=6f917fd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f917fd2"]])

export default __exports__